class InfiniteScroll {
  constructor() {
    this.isLoading = false;
    this.hasMore = true;
    this.findElements();
  }

  findElements() {
    this.container = document.querySelector('#product-grid');
    this.loader = document.querySelector('.infinite-scroll-loader');
    this.loadMoreTrigger = document.querySelector('.infinite-scroll-trigger');

    if (!this.container || !this.loadMoreTrigger) {
      // Retry after next frame
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.findElements();
        });
      });
      return;
    }

    this.init();
  }

  init() {
    // Create intersection observer for infinite scroll
    const options = {
      root: null,
      rootMargin: '400px', // Start loading 400px before reaching the trigger
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading && this.hasMore) {
          this.loadMore();
        }
      });
    }, options);

    this.observer.observe(this.loadMoreTrigger);
  }

  async loadMore() {
    if (this.isLoading || !this.hasMore) return;

    this.isLoading = true;
    this.showLoader();

    const nextUrl = this.loadMoreTrigger.dataset.nextUrl;

    if (!nextUrl) {
      this.hasMore = false;
      this.hideLoader();
      return;
    }

    try {
      const response = await fetch(nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Get new products
      const newProducts = doc.querySelectorAll('#product-grid > li');

      if (newProducts.length === 0) {
        this.hasMore = false;
        this.hideLoader();
        return;
      }

      // Append new products with animation
      newProducts.forEach((product, index) => {
        // Add animation delay
        if (product.style) {
          product.style.setProperty('--animation-order', this.container.children.length + index);
        }
        this.container.appendChild(product);
      });

      // Update next URL
      const nextTrigger = doc.querySelector('.infinite-scroll-trigger');
      if (nextTrigger && nextTrigger.dataset.nextUrl) {
        this.loadMoreTrigger.dataset.nextUrl = nextTrigger.dataset.nextUrl;
      } else {
        this.hasMore = false;
        this.observer.disconnect();
      }

      // Update product count if it exists
      const newCount = doc.querySelector('#ProductCountDesktop');
      const currentCount = document.querySelector('#ProductCountDesktop');
      if (newCount && currentCount) {
        currentCount.innerHTML = newCount.innerHTML;
      }

      this.hideLoader();
    } catch (error) {
      console.error('Error loading more products:', error);
      this.hideLoader();
    } finally {
      this.isLoading = false;
    }
  }

  showLoader() {
    if (this.loader) {
      this.loader.classList.add('active');
    }
  }

  hideLoader() {
    if (this.loader) {
      this.loader.classList.remove('active');
    }
  }
}

// Initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new InfiniteScroll();
  });
} else {
  new InfiniteScroll();
}

// Reinitialize after facet updates
document.addEventListener('facet:updated', () => {
  new InfiniteScroll();
});
